<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22.056"
    height="22.056"
    viewBox="0 0 22.056 22.056"
  >
    <g
      id="Group_2816"
      data-name="Group 2816"
      transform="translate(17.287) rotate(45)"
    >
      <rect
        id="Rectangle_1255"
        data-name="Rectangle 1255"
        width="6.744"
        height="10.96"
        transform="translate(0 5.901)"
        fill="#fff"
      />
      <path
        id="Path_2180"
        data-name="Path 2180"
        d="M0,0H6.744L3.373,5.058Z"
        transform="translate(0 19.39)"
        fill="#fff"
      />
      <path
        id="Rectangle_1256"
        data-name="Rectangle 1256"
        d="M1,0H5.744a1,1,0,0,1,1,1V3.372a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V1A1,1,0,0,1,1,0Z"
        transform="translate(0 0)"
        fill="#fff"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'EditSimplified',
}
</script>

<style lang="scss" scoped></style>
